<template>
  <ul class="action-list">
    <li>
      <v-dropdown :show-arrow="false">
        <a
          slot="activator"
          href="#"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          class="avatar"
        >
          <a href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i
            class="icon-fa icon-fa-bell"></i></a>
          <span v-if="activeNotifications && activeNotifications.length" class="badge badge-danger" aria-hidden="true">{{
              activeNotifications.length
            }}</span>
        </a>
        <v-dropdown-item>
          <span class="small_title">Уведомления</span>
        </v-dropdown-item>
        <template v-if="activeNotifications && activeNotifications.length">
          <v-dropdown-item v-for="(notification, i) in getActiveNotifications()" :key="i">
            <template v-if="+notification.type_id === types.moderateReadyInvoice">
              <a href="#" class="dropdown-item" @click.prevent="() => openInvoice(notification.sub_object_id)">
                <i class="icon-fa icon-fa-file-text-o"/> {{ notification.sub_object_id }} накладная на модерацию
              </a>
            </template>
            <template v-else>
              <a href="#" class="dropdown-item" @click.prevent="() => orderToEdit(notification.object_id)">
                <i class="icon-fa icon-fa-phone"/> {{ notification.object_id }} {{ notification.message }}
              </a>
            </template>
          </v-dropdown-item>
        </template>
        <template v-else>
          <v-dropdown-item>
            <a href="#" class="dropdown-item" @click.prevent="() => {}">
              <span>Нет активных уведомлений</span>
            </a>
          </v-dropdown-item>
        </template>
      </v-dropdown>
    </li>
  </ul>

</template>

<script>

export default {
  data() {
    return {
      notifications: null,
      activeNotifications: [],
      types: {
        moderateReadyInvoice: 5
      }
    }
  },
  watch: {
    '$ActiveNotifications': {
      handler: function (val, oldVal) {
        if (val) {
          // console.log('NEW NOTIFICATION', val, oldVal)
        }
      },
      deep: true
    },
    notifications() {
      if (this.notifications && this.notifications.length > 0) {
        let newNotification = this.notifications.pop().message
        if (newNotification) {
          newNotification = JSON.parse(newNotification[0]);
          this.updateNotifications(newNotification);
        }
      }
    }
  },
  mounted() {
    this.activeNotifications = [...(this.$ActiveNotifications.notifications || [])]
  },
  methods: {
    async getNewNotifications() {
      this.activeNotifications.push({
        type: 'order',
        object_id: 938059,
        message: 'Ожидает перезвон'
      })
    },
    getActiveNotifications() {
      return this.activeNotifications;
    },
    updateNotifications(notification) {
      this.activeNotifications.push({
        type: 'order',
        object_id: 938058,
        message: 'Ожидает перезвон'
      })
      console.log('update', notification)
    },
    openInvoice(id) {
      this.$store.dispatch('invoices/setInvoiceToEdit', {invoiceId: id});
    },
    orderToEdit(id) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: id})
    },
  }
}

</script>

<style scoped>
.badge {
  position: absolute;
  right: -5px;
}

.small_title {
  font-size: 12px;
  padding: 11px;
}
</style>
